
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyD8wckKXshEvdqR0d7iEk2BU6iL_32Rj7Y",
  authDomain: "cidade-melhor-br.firebaseapp.com",
  projectId: "cidade-melhor-br",
  storageBucket: "cidade-melhor-br.appspot.com",
  messagingSenderId: "515747370095",
  appId: "1:515747370095:web:f9176061237bfbf474a99a",
  measurementId: "G-CPN3SGSV9X"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db }; 
